import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import BrandHeader from "@/components/BrandHeader";
import { C } from "@/components/tablero/constants";
import { Capa3Section } from "@/components/tablero/Capa3Section";
import { Capa2Section } from "@/components/tablero/Capa2Section";
import { Capa1Section } from "@/components/tablero/Capa1Section";
import { ClosingBlock } from "@/components/tablero/ClosingBlock";

export default function ConsultingTablero() {
  const { testId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/consulting/tests/${testId}/tablero`)
      .then((r) => {
        setData(r.data);
        api.post(`/consulting/tests/${testId}/tablero/event`, { type: "tablero_abierto" }).catch(() => {});
      })
      .catch(() => setError(true));
  }, [testId]);

  const onSaved = (r) => setData(r);
  const capa1Top = data?.capa1?.top;
  const capa2Top = data?.capa2?.top;
  const capa3Top = data?.capa3?.top;

  return (
    <div className="min-h-screen bg-white" data-testid="tablero-page">
      <BrandHeader />
      <main className="mx-auto max-w-5xl px-4 md:px-6 pt-8 pb-24 space-y-6">
        <Link to={`/consulting/${testId}/report`} className="inline-flex items-center gap-2 text-sm font-semibold" style={{ color: C.green }} data-testid="tablero-back-to-report">
          <ArrowLeft className="w-4 h-4" /> Volver al informe
        </Link>
        {error && <p className="text-slate-500" data-testid="tablero-unavailable">El tablero de talento no está disponible para esta consultoría.</p>}
        {!data && !error && <Loader2 className="w-6 h-6 animate-spin" style={{ color: C.green }} />}
        {data && (
          <>
            <header className="rounded-2xl p-6 md:p-8 border" style={{ background: C.cream, borderColor: "#E3E7E1" }}>
              <div className="text-[10px] font-bold uppercase tracking-[0.22em]" style={{ color: C.gold }}>Tablero de talento</div>
              <h1 className="font-display text-3xl md:text-4xl font-bold mt-1" style={{ color: C.text }}>{data.company_name}</h1>
              <p className="text-sm mt-2" style={{ color: C.text }} data-testid="tablero-status-line">{data.status_line}</p>
            </header>
            {data.capa1 && <Capa1Section testId={testId} data={data.capa1} onSaved={onSaved} />}
            {data.capa2 && <Capa2Section testId={testId} data={data.capa2} onSaved={onSaved} />}
            {data.capa3 && <Capa3Section testId={testId} data={data.capa3} onSaved={onSaved} />}
            {(capa1Top || capa2Top || capa3Top) && <ClosingBlock capa1Top={capa1Top} capa2Top={capa2Top} capa3Top={capa3Top} testId={testId} />}
          </>
        )}
      </main>
    </div>
  );
}
